import './policy-manager-container.scss';
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { ServiceDto } from '../../../../dtos/customer.dto';
import { FwVersionInfo } from '../../../../dtos/version.dto';
import CustomSelect from '../../../shared/custom-select/custom-select';
import {
    ConnectionItemRenderer,
    PolicyItemRenderer,
    serviceComparatorByName
} from '../../../shared/label-renderer/label-renderer';
import { EventType } from '../../../../dtos/analytics.dto';
import { LevelName } from '../../../../utils/enums';

interface SelectConnectionProps {
    selectedConnection: ServiceDto | undefined;
    setConnection: (value: any) => void;
    versionsList: FwVersionInfo[] | undefined;
    selectedVersion: FwVersionInfo | undefined;
    setVersion: (value: any) => void;
}

export const SelectConnection: React.FC<SelectConnectionProps> = observer((
    {selectedConnection, setConnection, versionsList, selectedVersion, setVersion}) => {
    const {fwVersionStore, customerStore} = useStores();

    const setSelectedConnection = (value: number) => {
        if (customerStore.selectedCustomer) {
            const connectionsList = customerStore.selectedCustomer?.services;
            const connection = connectionsList?.find(service => service.serviceId === value);
            if (connection) {
                fwVersionStore.sendGeneralEvent(EventType.ConnectionSelected, { selectedConnectionID: connection.serviceName || connection.adiCircuitId });
                setConnection(connection);
            }
        }
    };

    const setSelectedVersion = (value: any) => {
        const version = versionsList?.find(_ => _.versionNumber === value);
        if (version) {
            fwVersionStore.sendGeneralEvent(EventType.PolicySelected, { selectedPolicyNumber: version.versionNumber });
            setVersion(version);
        }
    };

    const connections = useMemo(() =>
            (customerStore.selectedCustomer?.services?.slice()
                    .filter(_ => _.serviceLevel !== LevelName.BRONZE)
                    .sort(serviceComparatorByName)
                || [])
                .map(_ => {
                return { key: _.serviceId, value: _.serviceId, label: _.serviceName || _.adiCircuitId, data: _ };
            })
        , [customerStore.selectedCustomer?.services]);

    return <div className="selection-content">
        <CustomSelect placeholder={'Select Connection'}
                      className={'policy-manager-select-connection'}
                      onSelect={setSelectedConnection}
                      value={selectedConnection?.serviceId}
                      disabled={!customerStore.selectedCustomer}
                      options={connections}
                      emptyMessage={'No connection found'}
                      LabelRenderer={ConnectionItemRenderer}/>

        <CustomSelect placeholder={'Select Version'}
                      className={'policy-manager-select-policy'}
                      onSelect={setSelectedVersion}
                      value={selectedVersion?.versionNumber}
                      disabled={!fwVersionStore.selectedFwVersion || versionsList?.length === 1}
                      options={(versionsList || []).map(_ => {
                          return {
                              key: _.versionNumber,
                              value: _.versionNumber,
                              label: `${_.versionState} V${_.versionNumber} ${_.versionName}`,
                              data: _
                          };
                      })}
                      emptyMessage={'No version found'}
                      LabelRenderer={PolicyItemRenderer}/>
    </div>;
});
